export default __webpack_public_path__ + "img/d10806012bdede810d91f12935ca8d5f.png";